var _defs, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChrismongemeinde2025AblaufgrafikMobilRgb = function SvgChrismongemeinde2025AblaufgrafikMobilRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 361,
    height: 200,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 361 200",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_44",
    "data-name": "Unbenannter Verlauf 44",
    x1: -1664.94,
    y1: 2923.58,
    x2: -1649.44,
    y2: 2923.58,
    gradientTransform: "translate(1703.89 -2885.53) rotate(.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcf4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fae5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f7bea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f38079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ec2c38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb1527"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_39",
    "data-name": "Unbenannter Verlauf 39",
    cx: 40.32,
    cy: 1506.46,
    fx: 40.32,
    fy: 1506.46,
    r: 18.07,
    gradientTransform: "translate(0 -1413.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb5b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff9f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_59",
    "data-name": "Unbenannter Verlauf 59",
    x1: 32.17,
    y1: 93.93,
    x2: 48.42,
    y2: 93.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3daee4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#65bfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#87cddb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a3d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#b9e2d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#c8e9d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#d1ecd3"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.13,155.09v1.3h-5.4v6.26h-1.5v-13.34h7.32v1.3h-5.82v4.48h5.4Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.49,150.17c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM104.21,153.17v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.25,153.17c.14.4.2.78.2,1.38.64-1.1,1.6-1.64,2.86-1.64s2.3.58,2.72,1.54c.26.62.3.88.3,2.76v5.44h-1.4v-5.36c0-1.44-.04-1.78-.26-2.24-.3-.58-.86-.9-1.64-.9-.86,0-1.64.44-2.08,1.18-.28.5-.42,1.12-.42,2.02v5.3h-1.4v-6.26c0-2.26,0-2.34-.22-3.22h1.34Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.03,155.65c.2-1.78,1.44-2.74,3.54-2.74,1.54,0,2.68.58,3.04,1.56.18.48.22.94.22,2.12v3.56c0,1.54.04,1.84.26,2.5h-1.34c-.14-.44-.16-.66-.22-1.28-.56,1.02-1.48,1.52-2.78,1.52-1.86,0-3.06-1.08-3.06-2.74,0-1.32.76-2.3,2.2-2.84.92-.34,1.8-.54,3.56-.84v-.4c0-1.42-.54-1.96-1.94-1.96-1.22,0-1.9.48-2.1,1.54h-1.38ZM122.45,157.51c-3.2.56-4.32,1.24-4.32,2.54,0,.98.74,1.66,1.84,1.66.92,0,1.72-.44,2.12-1.18.24-.46.36-1.1.36-2.08v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.23,149.25v13.4h-1.48v-13.4h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05,158.15c.06,2.3,1.02,3.54,2.74,3.54,1.04,0,1.66-.4,2.2-1.44l1.3.16c-.58,1.64-1.78,2.48-3.52,2.48-2.54,0-4.16-1.9-4.16-4.88s1.6-5.1,4.08-5.1c2.34,0,3.84,1.9,3.84,4.84,0,.06,0,.22-.02.4h-6.46ZM137.07,157.05c-.16-1.92-1.02-2.96-2.44-2.96s-2.26,1.02-2.54,2.96h4.98Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.13,154.33c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16ZM143.13,161.72c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.11,180.15c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM94.93,175.85c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.15,175.57c1.66-.06,2.46-.64,2.76-2.02h1v13.1h-1.42v-10.14h-2.34v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.25,185.72c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.25,180.15c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM119.07,175.85c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.17,182.23v1.26h-2.24v3.28h-1.46v-3.28h-5.34v-1.12l5.28-8.82h1.5v8.68h2.26ZM132.55,175.43l-4,6.8h3.98l.02-6.8Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.67,185.72c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.93,173.25v5.3c.72-1.14,1.54-1.64,2.72-1.64,2.18,0,3.68,2,3.68,4.96s-1.54,5.02-3.84,5.02c-1.18,0-1.96-.48-2.62-1.58v.22c0,.38-.04.72-.16,1.12h-1.34c.14-.58.16-1.04.16-2.68v-10.72h1.4ZM149.91,181.95c0,2.24,1,3.72,2.5,3.72s2.48-1.48,2.48-3.8-.92-3.74-2.38-3.74c-1.58,0-2.6,1.5-2.6,3.82Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.45,174.17c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM160.17,177.17v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.03,179.77c-.14-1.16-.76-1.7-1.94-1.7-1.08,0-1.82.58-1.82,1.42,0,.78.4,1.08,2.2,1.6,1.56.46,2.14.74,2.54,1.2.36.42.54.98.54,1.64,0,1.82-1.32,2.96-3.44,2.96-2.3,0-3.58-1.14-3.58-3.18h1.36c.12,1.34.84,2,2.2,2,1.24,0,2.02-.66,2.02-1.66,0-.52-.2-.86-.64-1.12-.32-.2-.44-.24-2.08-.76-1.84-.56-2.54-1.26-2.54-2.58,0-1.6,1.32-2.68,3.26-2.68s3.18,1.02,3.28,2.86h-1.36Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.01,180.15c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM178.83,175.85c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.77,176.97c.12-2.22,1.48-3.52,3.72-3.52s3.6,1.3,3.6,3.24c0,1.36-.64,2.3-1.96,2.88,1.62.56,2.38,1.62,2.38,3.26,0,2.42-1.64,4-4.14,4s-4.06-1.42-4.06-3.68v-.2h1.32c.06,1.68,1,2.6,2.68,2.6s2.72-1,2.72-2.66-1.04-2.56-3.1-2.56c-.14,0-.26,0-.48.02v-1.28l.52.02c1.62,0,2.62-.86,2.62-2.3,0-1.26-.84-2.06-2.2-2.06s-2.12.72-2.32,2.24h-1.3Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.43,185.72c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.43,180.15c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM205.25,175.85c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.35,182.23v1.26h-2.24v3.28h-1.46v-3.28h-5.34v-1.12l5.28-8.82h1.5v8.68h2.26ZM218.73,175.43l-4,6.8h3.98l.02-6.8Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.85,185.72c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40.58,
    y: 176.85,
    width: 5.04,
    height: 10.66,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.07,173.13l-3.13,5.5c-1.04,1.91-.46,4.28,1.33,5.5s4.28.46,5.5-1.62l3.13-5.5-6.83-3.88h0Z",
    style: {
      fill: "#ffecde",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.91,173.13l3.13,5.5c1.04,1.91.46,4.28-1.33,5.5-1.79,1.22-4.28.46-5.5-1.62l-3.13-5.5,6.83-3.88h0Z",
    style: {
      fill: "#ffecde",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.93,163.86l-14.18-.65,8.7,11.31c.59.5,1.05.87,1.72,1.21,3.3,1.69,7.11.47,8.73-2.67s.29-7.01-2.91-8.65c-.59-.11-.93-.48-2.07-.54",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.8,
    y1: 163.23,
    x2: 36.16,
    y2: 173.18,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.47,167.5v-1.86c-.12-6.58,5.09-11.92,11.55-12.05,6.46-.12,11.92,5.09,12.05,11.55v1.86",
    style: {
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.27,
    cy: 167.25,
    r: 11.8,
    style: {
      fill: "#fff7bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.27,
    cy: 167.25,
    r: 9.81,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "42.65 160.67 44.88 160.67 45.25 173.83 42.9 173.83 42.77 164.76",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.65 164.76 41.03 167.5 39.05 166.25 42.65 160.67",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.32,148.9v1.24c0,3,1.97,5.48,4.34,5.48h.89",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.32,148.9v1.24c0,3-1.97,5.48-4.34,5.48h-.89",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.32,162.33v-1.24c0-3,1.97-5.48,4.34-5.48h.89",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.32,162.33v-1.24c0-3-1.97-5.48-4.34-5.48h-.89",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.05,
    y: 47.38,
    width: 5.04,
    height: 10.66,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.83,44.5l-2.68,4.71c-.89,1.64-.4,3.67,1.14,4.71s3.67.4,4.71-1.39l2.68-4.71-5.85-3.32h0Z",
    style: {
      fill: "#ffecde",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.67,44.5l2.68,4.71c.89,1.64.4,3.67-1.14,4.71s-3.67.4-4.71-1.39l-2.68-4.71,5.85-3.32h0Z",
    style: {
      fill: "#ffecde",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.93,35.79l-14.18-.65,8.7,11.31c.59.5,1.05.87,1.72,1.21,3.3,1.69,7.11.47,8.73-2.67s.29-7.01-2.91-8.65c-.59-.11-.93-.48-2.07-.54",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.8,
    y1: 35.17,
    x2: 36.16,
    y2: 45.12,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "34.18 22.24 38.28 11.9 45.59 12.12 49.04 22.54 46.91 23.95 45.84 26.42 45.64 27.63 44.49 23.95 43.09 22.38 40.7 22.52 39.21 24.29 37.44 27.18 36.29 23.78 34.46 22.8 34.18 22.24",
    style: {
      fill: "#ffecde"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.38 22.71 35.73 22.94 37.22 26 37.5 27.23 39.69 23.81 40.67 22.66 42.08 22.66 43.51 23.25 45 25.69 45.28 27.54 46.2 25.94 47.33 23.25 49.32 22.66 49.55 47.33 34.04 47.66 34.38 22.71",
    style: {
      fill: "url(#Unbenannter_Verlauf_44)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.32 22.38 41.77 2.91 34.1 22.32 34.13 47.58 49.43 47.61 49.32 22.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "41.77 2.91 37.58 13.89 45.95 13.89 41.77 2.91"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.42,29.82c0-4.1-1.69-7.36-3.82-7.36s-3.68,3.23-3.76,7.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.32,22.54c-2.13,0-3.9,3.34-3.82,7.36l-.03,17.56",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.16,22.38c2.13,0,3.9,3.34,3.82,7.36l-.03,17.84",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.35,11.36v1.09c0,2.63,1.73,4.8,3.8,4.8h.78",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.35,11.36v1.09c0,2.63-1.73,4.8-3.8,4.8h-.78",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.35,23.04v-1.09c0-2.63,1.73-4.8,3.8-4.8h.78",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.35,23.04v-1.09c0-2.63-1.73-4.8-3.8-4.8h-.78",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.2,94.9h-1.82l-1.58-1.66c-.98,1.14-2.28,1.72-3.78,1.72-3.2,0-5.42-2.82-5.42-6.9s2.22-6.9,5.44-6.9,5.42,2.82,5.42,6.88c0,1.54-.26,2.78-.88,4.04l2.62,2.82ZM92.2,88c0,3.4,1.54,5.66,3.84,5.66s3.82-2.28,3.82-5.58-1.56-5.6-3.84-5.6-3.82,2.28-3.82,5.52Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.52,85.25v5.8c0,1.06.1,1.58.36,1.94.32.46.9.72,1.58.72.84,0,1.52-.4,1.94-1.1.28-.48.38-1.04.38-1.98v-5.38h1.4v6.6c0,2.06,0,2.18.22,2.88h-1.38c-.14-.42-.18-.76-.2-1.26-.56,1.06-1.3,1.5-2.52,1.5s-2.3-.56-2.8-1.52c-.3-.52-.38-1.1-.38-2.4v-5.8h1.4Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.9,87.74c.2-1.78,1.44-2.74,3.54-2.74,1.54,0,2.68.58,3.04,1.56.18.48.22.94.22,2.12v3.56c0,1.54.04,1.84.26,2.5h-1.34c-.14-.44-.16-.66-.22-1.28-.56,1.02-1.48,1.52-2.78,1.52-1.86,0-3.06-1.08-3.06-2.74,0-1.32.76-2.3,2.2-2.84.92-.34,1.8-.54,3.56-.84v-.4c0-1.42-.54-1.96-1.94-1.96-1.22,0-1.9.48-2.1,1.54h-1.38ZM119.32,89.6c-3.2.56-4.32,1.24-4.32,2.54,0,.98.74,1.66,1.84,1.66.92,0,1.72-.44,2.12-1.18.24-.46.36-1.1.36-2.08v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.1,81.33v13.4h-1.48v-13.4h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.79,82.25c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM129.51,85.25v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,85.25v1.14h-2.3v8.34h-1.48v-8.34h-1.34v-1.14h1.34v-.6c0-1.42.08-1.9.4-2.44.4-.7,1.2-1.1,2.12-1.1.48,0,.94.1,1.5.3v1.3c-.5-.26-.9-.36-1.32-.36-.58,0-.98.28-1.14.82-.1.28-.14.72-.14,1.44v.64h2.36Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.21,82.25c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM139.93,85.25v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.27,81.33v13.4h-1.4v-13.4h1.4ZM150,85.25l-3.96,4.26,4.26,5.22h-1.94l-4.06-5.16,4-4.32h1.7Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.85,87.74c.2-1.78,1.44-2.74,3.54-2.74,1.54,0,2.68.58,3.04,1.56.18.48.22.94.22,2.12v3.56c0,1.54.04,1.84.26,2.5h-1.34c-.14-.44-.16-.66-.22-1.28-.56,1.02-1.48,1.52-2.78,1.52-1.86,0-3.06-1.08-3.06-2.74,0-1.32.76-2.3,2.2-2.84.92-.34,1.8-.54,3.56-.84v-.4c0-1.42-.54-1.96-1.94-1.96-1.22,0-1.9.48-2.1,1.54h-1.38ZM157.28,89.6c-3.2.56-4.32,1.24-4.32,2.54,0,.98.74,1.66,1.84,1.66.92,0,1.72-.44,2.12-1.18.24-.46.36-1.1.36-2.08v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.76,85.25v1.14h-2.26l-.1,4.8v.94c0,.66.02.9.14,1.14.12.28.46.44.92.44.42,0,.94-.12,1.36-.34v1.24c-.64.24-1.1.32-1.68.32-.94,0-1.64-.32-1.96-.9-.18-.32-.24-.66-.24-1.34,0-.18,0-.5.02-.8l.02-.74.12-4.76h-1.42v-1.14h1.46l.06-2.74h1.36l-.04,2.74h2.24Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.62,82.25c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM169.34,85.25v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,90c0,2.92-1.7,4.98-4.14,4.98s-4.14-2.04-4.14-5.06c0-2.86,1.72-4.92,4.14-4.92s4.14,2.04,4.14,5ZM173.15,89.94c0,2.32,1.06,3.84,2.7,3.84s2.7-1.52,2.7-3.8-1.08-3.78-2.7-3.78-2.7,1.52-2.7,3.74Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,85.25c.14.4.2.78.2,1.38.64-1.1,1.6-1.64,2.86-1.64s2.3.58,2.72,1.54c.26.62.3.88.3,2.76v5.44h-1.4v-5.36c0-1.44-.04-1.78-.26-2.24-.3-.58-.86-.9-1.64-.9-.86,0-1.64.44-2.08,1.18-.28.5-.42,1.12-.42,2.02v5.3h-1.4v-6.26c0-2.26,0-2.34-.22-3.22h1.34Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.67,86.41c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16ZM194.67,93.8c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.02,107.65c1.66-.06,2.46-.64,2.76-2.02h1v13.1h-1.42v-10.14h-2.34v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.26,107.65c1.66-.06,2.46-.64,2.76-2.02h1v13.1h-1.42v-10.14h-2.34v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.36,117.8c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.36,112.24c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM116.18,107.93c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.12,109.05c.12-2.22,1.48-3.52,3.72-3.52s3.6,1.3,3.6,3.24c0,1.36-.64,2.3-1.96,2.88,1.62.56,2.38,1.62,2.38,3.26,0,2.42-1.64,4-4.14,4s-4.06-1.42-4.06-3.68v-.2h1.32c.06,1.68,1,2.6,2.68,2.6s2.72-1,2.72-2.66-1.04-2.56-3.1-2.56c-.14,0-.26,0-.48.02v-1.28l.52.02c1.62,0,2.62-.86,2.62-2.3,0-1.26-.84-2.06-2.2-2.06s-2.12.72-2.32,2.24h-1.3Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.78,117.8c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.04,105.33v5.3c.72-1.14,1.54-1.64,2.72-1.64,2.18,0,3.68,2,3.68,4.96s-1.54,5.02-3.84,5.02c-1.18,0-1.96-.48-2.62-1.58v.22c0,.38-.04.72-.16,1.12h-1.34c.14-.58.16-1.04.16-2.68v-10.72h1.4ZM147.02,114.04c0,2.24,1,3.72,2.5,3.72s2.48-1.48,2.48-3.8-.92-3.74-2.38-3.74c-1.58,0-2.6,1.5-2.6,3.82Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.55,106.25c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM157.27,109.25v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.14,111.86c-.14-1.16-.76-1.7-1.94-1.7-1.08,0-1.82.58-1.82,1.42,0,.78.4,1.08,2.2,1.6,1.56.46,2.14.74,2.54,1.2.36.42.54.98.54,1.64,0,1.82-1.32,2.96-3.44,2.96-2.3,0-3.58-1.14-3.58-3.18h1.36c.12,1.34.84,2,2.2,2,1.24,0,2.02-.66,2.02-1.66,0-.52-.2-.86-.64-1.12-.32-.2-.44-.24-2.08-.76-1.84-.56-2.54-1.26-2.54-2.58,0-1.6,1.32-2.68,3.26-2.68s3.18,1.02,3.28,2.86h-1.36Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.12,112.24c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM175.93,107.93c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.15,107.65c1.66-.06,2.46-.64,2.76-2.02h1v13.1h-1.42v-10.14h-2.34v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,117.8c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.26,112.24c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM200.07,107.93c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.18,114.32v1.26h-2.24v3.28h-1.46v-3.28h-5.34v-1.12l5.28-8.82h1.5v8.68h2.26ZM213.55,107.51l-4,6.8h3.98l.02-6.8Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.67,117.8c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.88,
    y: 107.52,
    width: 5.04,
    height: 10.66,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.28,104.65l14.18-.65-8.7,11.31c-.59.5-1.05.87-1.72,1.21-3.3,1.69-7.11.47-8.73-2.67-1.61-3.14-.29-7.01,2.91-8.65.59-.11.93-.48,2.07-.54",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.41,
    y1: 104.03,
    x2: 43.06,
    y2: 113.98,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.37,76.55v1.23c0,2.83,1.88,5.16,3.99,5.16h.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.37,76.55v1.23c0,2.83-1.88,5.16-3.99,5.16h-.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.37,89.1v-1.23c0-2.83,1.88-5.16,3.99-5.16h.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.37,89.1v-1.23c0-2.83-1.88-5.16-3.99-5.16h-.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_13-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "26.27 87.28 24.09 89.04 22.33 91.89 22.84 95.31 25.01 97.91 26.18 98.74 26.1 102.42 27.6 105.77 29.53 107.02 32.54 107.11 34.63 107.11 36.39 109.37 39.65 111.04 42.41 111.04 44.33 109.11 46.09 107.19 49.18 107.36 52.19 107.11 53.95 104.77 54.7 102.42 54.28 98.91 56.63 97.07 58.38 94.81 58.38 93.06 57.55 90.3 55.87 88.29 54.45 87.28 54.7 84.44 54.28 82.1 52.7 80.01 50.6 78.92 48.18 78.67 45.92 78.67 44.58 76.91 42.66 75.58 40.32 74.99 37.47 75.91 35.38 77.83 34.63 78.92 31.62 78.67 29.61 78.92 27.02 81.01 26.1 83.19 26.27 85.78 26.27 87.28",
    style: {
      fill: "url(#Unbenannter_Verlauf_39)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.63,78.84c1.42-2.43,3.43-3.85,5.69-3.85s4.18,1.42,5.6,3.68",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.63,107.11c1.42,2.43,3.43,3.93,5.77,3.93s4.27-1.51,5.69-3.85",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.18,98.66c-2.43-1.42-3.93-3.43-3.93-5.69s1.51-4.35,3.93-5.77",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.45,98.74c2.43-1.42,3.93-3.43,3.93-5.77s-1.51-4.35-3.93-5.77",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.32,103.85c-4.43,3.76-9.95,4.6-12.71,1.84-2.76-2.76-1.92-8.28,1.92-12.71",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.27,92.89c3.68-4.43,4.6-9.87,1.84-12.63s-8.28-1.84-12.71,1.92",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.32,82.1c-4.43-3.76-9.95-4.6-12.71-1.84s-1.92,8.28,1.92,12.71",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.19,92.97c3.76,4.52,4.68,9.95,1.92,12.71-2.76,2.76-8.28,1.84-12.8-1.92",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.17,94.11v-1.28c-.09-4.53,3.51-8.21,7.96-8.3s8.21,3.51,8.3,7.96v1.28",
    style: {
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.3,
    cy: 93.93,
    r: 8.13,
    style: {
      fill: "url(#Unbenannter_Verlauf_59)",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.3,
    cy: 93.93,
    r: 6.76,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40 97.27 36.93 94.47 38.08 93.21 39.81 94.78 42.73 91.12 44.07 92.19 40 97.27",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.14,11.58c1.8,0,2.52.08,3.26.32,1.3.44,2.06,1.54,2.06,3s-.7,2.44-2.22,2.92c2,.48,2.92,1.56,2.92,3.38,0,1.64-.88,2.96-2.24,3.38-.86.28-1.6.34-3.9.34h-2.32v-13.34h2.44ZM95.44,17.32c1.3,0,1.94-.1,2.5-.42.64-.34,1-1.06,1-1.9,0-.92-.44-1.64-1.2-1.92-.52-.2-.98-.24-2.38-.24h-1.18v4.48h1.26ZM95.52,23.67c1.6,0,2.28-.08,2.88-.34.74-.32,1.18-1.14,1.18-2.2,0-1.12-.58-1.98-1.52-2.3-.6-.18-1.12-.24-2.54-.24h-1.34v5.08h1.34Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.3,20.43c.06,2.3,1.02,3.54,2.74,3.54,1.04,0,1.66-.4,2.2-1.44l1.3.16c-.58,1.64-1.78,2.48-3.52,2.48-2.54,0-4.16-1.9-4.16-4.88s1.6-5.1,4.08-5.1c2.34,0,3.84,1.9,3.84,4.84,0,.06,0,.22-.02.4h-6.46ZM109.32,19.32c-.16-1.92-1.02-2.96-2.44-2.96s-2.26,1.02-2.54,2.96h4.98Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.26,15.44l2.04,7.52,2.22-7.52h1.2l2.22,7.52,2.04-7.52h1.44l-2.74,9.6h-1.38l-2.18-7.44-2.2,7.44h-1.36l-2.74-9.6h1.44Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.94,20.43c.06,2.3,1.02,3.54,2.74,3.54,1.04,0,1.66-.4,2.2-1.44l1.3.16c-.58,1.64-1.78,2.48-3.52,2.48-2.54,0-4.16-1.9-4.16-4.88s1.6-5.1,4.08-5.1c2.34,0,3.84,1.9,3.84,4.84,0,.06,0,.22-.02.4h-6.46ZM131.96,19.32c-.16-1.92-1.02-2.96-2.44-2.96s-2.26,1.02-2.54,2.96h4.98Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.98,15.44c.12.48.18.98.18,1.46,0,.12,0,.32-.02.58.66-1.58,1.42-2.3,2.44-2.3.36,0,.74.1,1.14.3v1.4c-.64-.3-.9-.38-1.26-.38-.74,0-1.4.54-1.82,1.46-.3.66-.42,1.46-.42,2.72v4.24h-1.42v-6.22c0-2.16-.02-2.34-.16-3.26h1.34Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.72,11.52v5.3c.72-1.14,1.54-1.64,2.72-1.64,2.18,0,3.68,2,3.68,4.96s-1.54,5.02-3.84,5.02c-1.18,0-1.96-.48-2.62-1.58v.22c0,.38-.04.72-.16,1.12h-1.34c.14-.58.16-1.04.16-2.68v-10.72h1.4ZM143.7,20.23c0,2.24,1,3.72,2.5,3.72s2.48-1.48,2.48-3.8-.92-3.74-2.38-3.74c-1.58,0-2.6,1.5-2.6,3.82Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.84,15.44v5.8c0,1.06.1,1.58.36,1.94.32.46.9.72,1.58.72.84,0,1.52-.4,1.94-1.1.28-.48.38-1.04.38-1.98v-5.38h1.4v6.6c0,2.06,0,2.18.22,2.88h-1.38c-.14-.42-.18-.76-.2-1.26-.56,1.06-1.3,1.5-2.52,1.5s-2.3-.56-2.8-1.52c-.3-.52-.38-1.1-.38-2.4v-5.8h1.4Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.52,15.44c.14.4.2.78.2,1.38.64-1.1,1.6-1.64,2.86-1.64s2.3.58,2.72,1.54c.26.62.3.88.3,2.76v5.44h-1.4v-5.36c0-1.44-.04-1.78-.26-2.24-.3-.58-.86-.9-1.64-.9-.86,0-1.64.44-2.08,1.18-.28.5-.42,1.12-.42,2.02v5.3h-1.4v-6.26c0-2.26,0-2.34-.22-3.22h1.34Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.26,16.5l-1.94-.04c.52.48.82,1.3.82,2.18s-.34,1.72-.96,2.16c-.42.32-1.08.56-2.14.78-.94.2-1.14.26-1.44.4-.36.18-.56.4-.56.64,0,.4.22.48,1.9.64,1.86.18,2.42.3,3.04.64.76.44,1.2,1.22,1.2,2.16,0,1.82-1.64,2.94-4.3,2.94s-4.26-1.08-4.26-2.74c0-1.14.6-1.84,2-2.34-.74-.28-1.02-.6-1.02-1.1,0-.64.46-1.06,1.7-1.52-1.3-.52-1.9-1.4-1.9-2.74,0-1.96,1.38-3.24,3.48-3.24.52,0,.92.06,1.48.22l2.9-.1v1.06ZM172.9,26.19c0,1,1.18,1.66,3,1.66s2.92-.64,2.92-1.66-1.06-1.64-3.02-1.64c-1.84,0-2.9.6-2.9,1.64ZM173.74,18.53c0,1.18.82,1.96,2.04,1.96s2.04-.78,2.04-1.96-.82-2.08-1.96-2.08c-1.26,0-2.12.84-2.12,2.08Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.4,16.6c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16ZM184.4,23.99c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.24,41.92c.2-1.78,1.44-2.74,3.54-2.74,1.54,0,2.68.58,3.04,1.56.18.48.22.94.22,2.12v3.56c0,1.54.04,1.84.26,2.5h-1.34c-.14-.44-.16-.66-.22-1.28-.56,1.02-1.48,1.52-2.78,1.52-1.86,0-3.06-1.08-3.06-2.74,0-1.32.76-2.3,2.2-2.84.92-.34,1.8-.54,3.56-.84v-.4c0-1.42-.54-1.96-1.94-1.96-1.22,0-1.9.48-2.1,1.54h-1.38ZM97.66,43.79c-3.2.56-4.32,1.24-4.32,2.54,0,.98.74,1.66,1.84,1.66.92,0,1.72-.44,2.12-1.18.24-.46.36-1.1.36-2.08v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.36,35.52v5.3c.72-1.14,1.54-1.64,2.72-1.64,2.18,0,3.68,2,3.68,4.96s-1.54,5.02-3.84,5.02c-1.18,0-1.96-.48-2.62-1.58v.22c0,.38-.04.72-.16,1.12h-1.34c.14-.58.16-1.04.16-2.68v-10.72h1.4ZM103.34,44.23c0,2.24,1,3.72,2.5,3.72s2.48-1.48,2.48-3.8-.92-3.74-2.38-3.74c-1.58,0-2.6,1.5-2.6,3.82Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.04,42.04c-.14-1.16-.76-1.7-1.94-1.7-1.08,0-1.82.58-1.82,1.42,0,.78.4,1.08,2.2,1.6,1.56.46,2.14.74,2.54,1.2.36.42.54.98.54,1.64,0,1.82-1.32,2.96-3.44,2.96-2.3,0-3.58-1.14-3.58-3.18h1.36c.12,1.34.84,2,2.2,2,1.24,0,2.02-.66,2.02-1.66,0-.52-.2-.86-.64-1.12-.32-.2-.44-.24-2.08-.76-1.84-.56-2.54-1.26-2.54-2.58,0-1.6,1.32-2.68,3.26-2.68s3.18,1.02,3.28,2.86h-1.36Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.6,44.19c0,2.92-1.7,4.98-4.14,4.98s-4.14-2.04-4.14-5.06c0-2.86,1.72-4.92,4.14-4.92s4.14,2.04,4.14,5ZM126.76,44.13c0,2.32,1.06,3.84,2.7,3.84s2.7-1.52,2.7-3.8-1.08-3.78-2.7-3.78-2.7,1.52-2.7,3.74Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.94,39.44v1.14h-2.3v8.34h-1.48v-8.34h-1.34v-1.14h1.34v-.6c0-1.42.08-1.9.4-2.44.4-.7,1.2-1.1,2.12-1.1.48,0,.94.1,1.5.3v1.3c-.5-.26-.9-.36-1.32-.36-.58,0-.98.28-1.14.82-.1.28-.14.72-.14,1.44v.64h2.36Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.28,44.19c0,2.92-1.7,4.98-4.14,4.98s-4.14-2.04-4.14-5.06c0-2.86,1.72-4.92,4.14-4.92s4.14,2.04,4.14,5ZM142.44,44.13c0,2.32,1.06,3.84,2.7,3.84s2.7-1.52,2.7-3.8-1.08-3.78-2.7-3.78-2.7,1.52-2.7,3.74Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.84,39.44c.12.48.18.98.18,1.46,0,.12,0,.32-.02.58.66-1.58,1.42-2.3,2.44-2.3.36,0,.74.1,1.14.3v1.4c-.64-.3-.9-.38-1.26-.38-.74,0-1.4.54-1.82,1.46-.3.66-.42,1.46-.42,2.72v4.24h-1.42v-6.22c0-2.16-.02-2.34-.16-3.26h1.34Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.92,39.44v1.14h-2.26l-.1,4.8v.94c0,.66.02.9.14,1.14.12.28.46.44.92.44.42,0,.94-.12,1.36-.34v1.24c-.64.24-1.1.32-1.68.32-.94,0-1.64-.32-1.96-.9-.18-.32-.24-.66-.24-1.34,0-.18,0-.5.02-.8l.02-.74.12-4.76h-1.42v-1.14h1.46l.06-2.74h1.36l-.04,2.74h2.24Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.42,35.52v5.3c.72-1.14,1.54-1.64,2.72-1.64,2.18,0,3.68,2,3.68,4.96s-1.54,5.02-3.84,5.02c-1.18,0-1.96-.48-2.62-1.58v.22c0,.38-.04.72-.16,1.12h-1.34c.14-.58.16-1.04.16-2.68v-10.72h1.4ZM171.4,44.23c0,2.24,1,3.72,2.5,3.72s2.48-1.48,2.48-3.8-.92-3.74-2.38-3.74c-1.58,0-2.6,1.5-2.6,3.82Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.94,36.44c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM181.66,39.44v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,42.04c-.14-1.16-.76-1.7-1.94-1.7-1.08,0-1.82.58-1.82,1.42,0,.78.4,1.08,2.2,1.6,1.56.46,2.14.74,2.54,1.2.36.42.54.98.54,1.64,0,1.82-1.32,2.96-3.44,2.96-2.3,0-3.58-1.14-3.58-3.18h1.36c.12,1.34.84,2,2.2,2,1.24,0,2.02-.66,2.02-1.66,0-.52-.2-.86-.64-1.12-.32-.2-.44-.24-2.08-.76-1.84-.56-2.54-1.26-2.54-2.58,0-1.6,1.32-2.68,3.26-2.68s3.18,1.02,3.28,2.86h-1.36Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.52,47.99c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.96,42.36c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM201.78,38.05c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,37.77c1.66-.06,2.46-.64,2.76-2.02h1v13.1h-1.42v-10.14h-2.34v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.1,47.92c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.1,42.36c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM225.92,38.05c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.02,44.44v1.26h-2.24v3.28h-1.46v-3.28h-5.34v-1.12l5.28-8.82h1.5v8.68h2.26ZM239.4,37.63l-4,6.8h3.98l.02-6.8Z",
    style: {
      fill: "#eb1426"
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChrismongemeinde2025AblaufgrafikMobilRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chrismongemeinde2025-ablaufgrafik-mobil-rgb.038cd2071969f65dee2736826d73aca0.svg";